import {
  EyeInvisibleFilled,
  EyeOutlined
} from "@ant-design/icons";
import { Button, Col, Popconfirm, Popover, Row, Space, message } from "antd";
import { ReactComponent as DownloadIcon } from "assets/images/icons/download.svg";
import AppLatex from "components/appLatex";
import Matiers from "components/matiers";
import moment from "moment";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsContributionUpdated } from "store/app/appSlice";
import {
  useChangeContributionStateMutation,
  useDeleteContributionMutation,
} from "store/services/teacher/contributions.services";
import s from "./style.module.css";

import { UserRoles } from "common/enums";
import OrganismeIcon from "../../../../assets/images/app/iam_organism.svg";
import MoreOptions from "../../../../assets/images/app/more_options.svg";
import { ReactComponent as TrashIcon } from "../../../../assets/images/app/trash_icon.svg";

type Props = {
  contribution?: any;
};

const CardContribution: FC<Props> = ({ contribution }) => {

  const dispatch = useDispatch();

  const [
    deleteContribution,
    { isSuccess: isSuccessDelete, isError, isLoading: isLoadingDelete },
  ] = useDeleteContributionMutation();

  const [
    changeContributionState,
    { isLoading: isLoadingState, isSuccess: isSuccessState },
  ] = useChangeContributionStateMutation();

  const { user, idTeacher } = useSelector((state) => state.auth);

  function convertToKiloOctets(bytes: number): number {
    const KILO: number = 1024;
    const kiloOctets: number = bytes / KILO;
    return Math.round(kiloOctets);
  }

  useEffect(() => {
    if (isSuccessDelete) {
      message.success("Supprimé avec succès");
      dispatch(setIsContributionUpdated(true));
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isSuccessState) {
      message.success("Statut modifié avec succès");
      dispatch(setIsContributionUpdated(true));
    }
  }, [isSuccessState]);

  return (
    <div className={s.card}>
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.user__infos}>
            <div style={{ height: "50px", width: "50px", border: "1px solid #FFF", borderRadius: "50%" }}>
              <img src={contribution?.profId?.profile || contribution?.organismeId?.profile || OrganismeIcon} height={45} style={{ borderRadius: "50%" }} />
            </div>
            <div>
              <h3>
                {contribution?.profId?.firstname
                  ? `${contribution.profId.firstname} ${contribution.profId.lastname}`
                  : contribution?.organismeId?.organisationName}
              </h3>

              <span>
                publiée le {moment(contribution?.createdAt).format("LL")}
              </span>
            </div>
          </div>

          <div className="right">
            <Space>
              {contribution?.classe[0]?.level?.title && contribution?.classe[0]?.course?.title && <Matiers
                level={contribution?.classe[0]?.level?.title}
                cours={contribution?.classe[0]?.course?.title}
              />}

              {user && (user.roles.includes(UserRoles?.TEACHER) || user.roles.includes(UserRoles?.ORGANISME)) &&
                (user?._id === contribution?.classe[0]?.teacher || user?._id === contribution?.classe[0]?.organism) && (
                  <Popover
                    placement="left"
                    title={false}
                    style={{ border: "1px solid #FAFAFA", borderRadius: "16px !important" }}
                    content={
                      <div>
                        <div style={{ marginBottom: "1em" }}>
                          {contribution?.display ? (
                            <Button
                              style={{ width: "100%", border: "none", display: "flex", alignItems: "center" }}
                              icon={<EyeInvisibleFilled />}
                              onClick={() =>
                                changeContributionState({
                                  idContribution: contribution?._id,
                                  action: "disable",
                                })
                              }
                              loading={isLoadingState}
                            >
                              Privé
                            </Button>
                          ) : (
                            <Button
                              style={{ width: "100%", border: "none", display: "flex", alignItems: "center" }}
                              icon={<EyeOutlined />}
                              onClick={() =>
                                changeContributionState({
                                  idContribution: contribution?._id,
                                  action: "enable",
                                })
                              }
                              loading={isLoadingState}
                            >
                              Publique
                            </Button>
                          )}
                        </div>

                        <div style={{ width: "100%" }}>
                          <Popconfirm
                            title="Êtes-vous sûr ?"
                            onConfirm={async () =>
                              await deleteContribution(contribution?._id)
                            }
                            okText="Oui"
                            cancelText="Non"
                          >
                            <Button
                              style={{ width: "100%", border: "none", display: "flex", alignItems: "center", color: "red" }}
                              icon={<TrashIcon color="red" height={15} style={{ filter: "invert(39%) sepia(100%) saturate(7463%) hue-rotate(359deg) brightness(100%) contrast(100%)", opacity: "0.7", marginRight: "7px" }} />}
                              loading={isLoadingDelete}
                            >
                              Supprimer
                            </Button>
                          </Popconfirm>
                        </div>
                      </div>
                    }
                    trigger="click"
                  >
                    <img src={MoreOptions} height={3} />
                  </Popover>
                )}

              {/* {user?._id === contribution?.classe[0]?.teacher && (
                <>
                  {contribution?.display ? (
                    <UnlockOutlined />
                  ) : (
                    <LockOutlined />
                  )}
                </>
              )} */}
            </Space>
          </div>
        </div>

        <div className={s.body}>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "#000" }}>{contribution?.title}</div>
          <AppLatex content={contribution?.content} />
        </div>

        <div className={s.footer}>
          <Row gutter={24}>
            {contribution?.links?.map((link: any, index: any) => (
              <Col key={index}>
                <Space>
                  <div>
                    <a href={link?.url} target="_blank">
                      <DownloadIcon width={28} />
                    </a>
                  </div>
                  <div>
                    <a href={link?.url} target="_blank">
                      <h4>{link?.name ?? `Fichier ${link?.type.split("/")[1].toUpperCase()}`}</h4>
                    </a>
                    <span>
                      Télécharger le {link?.type.split("/")[1].toUpperCase()} | {convertToKiloOctets(link?.size)}ko
                    </span>
                  </div>
                </Space>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CardContribution;
